import React from "react";
import "./intro.css";
import Typewriter from "typewriter-effect";
import ProductList from "../productList/ProductList";
import About from "../about/About";
import Contact from "../contact/Contact";
import { sliderItems } from "../../data";
import { useState } from "react";
import styled from "styled-components";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@material-ui/icons";
import { mobile } from "../../responsive";
const Container = styled.div`
  width: 70vw;
  height: 100vh;
  display: flex;
  position: relative;
  overflow: hidden;
  ${mobile({ width: "100vw", height: "70vw" })}
`;
const Arrow = styled.div`
  width: 50px;
  height: 50px;
  background-color: rgb(39, 150, 224);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${(props) => props.direction === "left" && "10px"};
  right: ${(props) => props.direction === "right" && "10px"};
  margin: auto;
  cursor: pointer;
  opacity: 0.5;
  z-index: 2;
`;

const Wrapper = styled.div`
  height: 40%;
  display: flex;
  transform: translateX(${(props) => props.slideIndex * -100}vw);
  transition: all 1.5s ease;
`;

const Slide = styled.div`
  width: 90vw;
  height: 90vh;
  display: flex;
  align-items: center;
  margin-top: 10px;
  background-color: #${(props) => props.bg};
  ${mobile({ width: "100vw", height: "100vw" })}
`;
const ImgContainer = styled.div`
  height: 100%;
  flex: 1;
  width: 100%;
`;
const Image = styled.img`
  height: 100%;

  border-radius: 10px;
  ${mobile({
    height: "80%",
    width: "70%",
    marginLeft: "60px",
  })}
`;
const InfoContainer = styled.div`
  flex: 1;
  padding: 5px;
  ${mobile({ display: "none" })}
`;

const Title = styled.h1`
  font-size: 70px;
  margin-left: -100px;
  ${mobile({ fontSize: "20px" })}
`;
const Desc = styled.p`
  margin-top: 50p;
  margin-bottom: 50px;
  margin-left: -90px;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 3px;
  ${mobile({ fontSize: "16px" })}
`;
const Intro = () => {
  const [slideIndex, setSlideIndex] = useState(0);
  const handleClick = (direction) => {
    if (direction === "left") {
      setSlideIndex(slideIndex > 0 ? slideIndex - 1 : 2);
    } else {
      setSlideIndex(slideIndex < 2 ? slideIndex + 1 : 0);
    }
  };

  return (
    <div className="container">
      <div className="i">
        <div className="i-left">
          <div className="i-left-wrapper">
            <h2 className="i-intro">Hello, My name is</h2>
            <h1 className="i-name">
              <Typewriter
                options={{
                  strings: ["Rahmat Saeedi"],
                  autoStart: true,
                  loop: true,
                  delay: 300,
                }}
              />
            </h1>
            <div className="i-title">
              <div className="i-title-wrapper">
                <div className="i-title-item">Full-Stack Developer</div>
                <div className="i-title-item">Mobile App Developer</div>
                <div className="i-title-item">Web Developer</div>
                <div className="i-title-item">Web Designer</div>
                <div className="i-title-item">Database Developer</div>
              </div>
            </div>
            <p className="i-desc">
              I DESIGN AND DEVELOP ANY KIND OF MODERN WEBSITES USING THE LATEST
              TECHNOLOGIES !
            </p>
          </div>
        </div>
        <div className="i-right">
          <Container>
            <Arrow direction="left" onClick={() => handleClick("left")}>
              <ArrowLeftOutlined />
            </Arrow>
            <Wrapper slideIndex={slideIndex}>
              {sliderItems.map((item) => (
                <Slide bg={item.bg} key={item.id}>
                  <ImgContainer>
                    <Image src={item.img} />
                  </ImgContainer>
                  <InfoContainer>
                    <Title>{item.title}</Title>
                    <Desc>
                      <small>{item.desc}</small>
                    </Desc>
                  </InfoContainer>
                </Slide>
              ))}
              ;
            </Wrapper>
            <Arrow direction="right" onClick={() => handleClick("right")}>
              <ArrowRightOutlined />
            </Arrow>
          </Container>
        </div>
      </div>
      <ProductList />
      <About />
      <Contact />
    </div>
  );
};

export default Intro;
